import { useState, useRef, useEffect } from 'react';
import { quotationContactsAPI } from '../../services/quotationService';

export default function ContactSearch({ onSelect }) {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleChange = (val) => {
    setQuery(val);
    if (timerRef.current) clearTimeout(timerRef.current);
    if (val.trim().length < 2) {
      setResults([]);
      setIsOpen(false);
      return;
    }
    timerRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const data = await quotationContactsAPI.search(val.trim());
        setResults(data);
        setIsOpen(data.length > 0);
      } catch (err) {
        console.error('Error searching contacts:', err);
      }
      setLoading(false);
    }, 300);
  };

  const handleSelect = (contact) => {
    const displayName = contact.first_name
      ? `${contact.first_name} ${contact.last_name || ''}`.trim()
      : contact.name || contact.phone;
    setQuery(displayName);
    setIsOpen(false);
    onSelect({ phone: contact.phone, name: displayName });
  };

  return (
    <div ref={wrapperRef} className="relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Vincular a contacto (opcional)
      </label>
      <input
        type="text"
        value={query}
        onChange={(e) => handleChange(e.target.value)}
        placeholder="Buscar por telefono o nombre..."
        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
      />
      {loading && (
        <div className="absolute right-3 top-9 text-gray-400 text-xs">Buscando...</div>
      )}
      {isOpen && results.length > 0 && (
        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-y-auto">
          {results.map((c, i) => (
            <button
              key={i}
              onClick={() => handleSelect(c)}
              className="w-full px-3 py-2 text-left hover:bg-blue-50 text-sm border-b border-gray-100 last:border-0"
            >
              <span className="font-medium">{c.first_name ? `${c.first_name} ${c.last_name || ''}`.trim() : c.name}</span>
              <span className="text-gray-400 ml-2">{c.phone}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
